import api from "./api";

const examManagementService = {
  // Get all exams for a teacher
  getTeacherExams: (teacherId) => api.get(`/exams/teacher/${teacherId}`),

  // Get exams by subject and class
  getExamsBySubjectClass: (subjectId, classId) =>
    api.get(`/exams/subject/${subjectId}/class/${classId}`),

  // Get teacher's assigned subjects and classes
  getTeacherAssignments: (teacherId) =>
    api.get(`/teachers/${teacherId}/assignments`),

  // Create new exam
  createExam: (examData) => api.post("/exams", examData),

  // Update exam
  updateExam: (examId, examData) => api.put(`/exams/${examId}`, examData),

  // Delete exam
  deleteExam: (examId) => api.delete(`/exams/${examId}`),

  // Get students for an exam (with current marks)
  getExamStudents: (examId, params = {}) => api.get(`/exam/${examId}/students`, { params }),

  // Get students by class
  getStudentsByClass: (classId) => api.get(`/classes/${classId}/students`),

  // Mark student scores
  markStudentScores: (examId, scores) =>
    api.post(`/exam/${examId}/scores`, { scores }),

  // Update individual score
  updateStudentScore: (examId, studentId, scoreData) =>
    api.put(`/exams/${examId}/students/${studentId}/score`, scoreData),

  // Get exam results/scores
  getExamResults: (examId) => api.get(`/exams/${examId}/results`),

  // Publish exam results
  publishResults: (examId) => api.post(`/exams/${examId}/publish`),

  // Download exam report
  downloadExamReport: (examId, format = "pdf") =>
    api.get(`/exams/${examId}/report`, {
      params: { format },
      responseType: "blob",
    }),

  // Get class performance summary
  getClassPerformance: (classId, subjectId) =>
    api.get(`/exams/performance/class/${classId}/subject/${subjectId}`),

  // Get student performance across exams
  getStudentPerformance: (studentId, subjectId) =>
    api.get(`/exams/performance/student/${studentId}/subject/${subjectId}`),

  // Bulk upload scores from file
  bulkUploadScores: (examId, file) => {
    const formData = new FormData();
    formData.append("file", file);
    return api.post(`/exam/${examId}/scores/bulk`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });
  },

  // Download marks template CSV
  downloadMarksTemplate: (examId) =>
    api.get(`/exam/${examId}/template`, { responseType: "blob" }),

  // Get exam types
  getExamTypes: () => api.get("/exams/types"),

  // Get grading scales
  getGradingScales: () => api.get("/exams/grading-scales"),
};

export default examManagementService;
